"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.redeemErrorCodeToI18nString = void 0;
const i18n_1 = require("@completeanatomy/i18n");
const api_1 = require("../../service/api");
exports.redeemErrorCodeToI18nString = {
    [api_1.PurchasesAPIErrorCode.Expired]: i18n_1.Strings.popups.redeemCodeError.expired,
    [api_1.PurchasesAPIErrorCode.MaxCountReached]: i18n_1.Strings.popups.redeemCodeError.maxCountReached,
    [api_1.PurchasesAPIErrorCode.InvalidDomain]: i18n_1.Strings.popups.redeemCodeError.invalidDomain,
};
